import {
    RiArrowRightSLine,
    RiBookMarkedLine,
    RiChatNewLine,
    RiCheckboxCircleFill, RiDashboardLine,
    RiFlashlightLine,
    RiPriceTag3Line,
    RiSettings3Line,
    RiStackLine, RiTeamLine, RiThumbUpLine, RiTicketLine, RiTimeLine,
    RiUser3Fill,
    RiUserLine,
} from "@remixicon/react";
import React, {
    ReactElement, ReactNode,
    useMemo,
} from "react";
import classNames from "classnames";
import {
    OnboardingProfile,
    Permission, useGetOnboardingProfileQuery, useGetReportsDataQuery, useSaveOnboardingProfileMutation,
} from "../../__generated__/api";
import { ARTICLES } from "../../components/help/Help";
import TopPanel from "../../components/top-panel/TopPanel";
import useArticleContext from "../../contexts/HelpContext";
import useRouting, { NavLink, Paths } from "../../contexts/Routing";
import useCurrentSession from "../../contexts/session";
import Styles from "./Home.module.scss";
// import { ReactComponent as MicrosoftTeamsLine } from "../../assets/icons/microsoft-teams-line.svg";
import Badge from "../../components/theme/badge/Badge";
import RouterLink from "../../components/theme/button/RouterLink";
import Icon from "../../components/theme/icon/Icon";
import ProgressBar from "../../components/theme/progress-bar/ProgressBar";
import Footer from "../administrator/sections/home/Footer";
import { STEPS, useProfile } from "../administrator/sections/home/HomeV3";
import ReportDisplay, { RowGroup } from "../reports/ReportDisplay";
import { LoadingIcon } from "../../components/loading/Loading";
import Text from "../../components/theme/text/Text";
import Time from "../../components/time/Time";
import { ShortDateRange } from "../../components/pickers/date-range/DateRangeCalendarPicker";

const REPORT_ID = "urn:fq:metrics-dashboard:HOME_TEMPLATE";

const CREATE_REQUEST_ID = "create-agent-request";
const CLEAR_REQUEST_ID = "clear-agent-request";
const NEXT_STEPS = [
    {
        id: "tickets",
        to: Paths.AGENT,
        params: Object.create(null),
        icon: <RiPriceTag3Line />,
        title: "Inbox",
        shouldShowAlways: true,
        showPermission: Permission.ChatsModifyAll,
        hidePermission: undefined,
        description: "View the main ticket inbox.",
    },
    {
        id: "my-tickets",
        to: Paths.TICKETS,
        params: Object.create(null),
        icon: <RiPriceTag3Line />,
        title: "My Tickets",
        shouldShowAlways: true,
        showPermission: Permission.TicketsReadSelf,
        hidePermission: Permission.ChatsModifyAll,
        description: "View my tickets.",

    },
    {
        id: "create-ticket",
        to: Paths.TICKETS_CREATE,
        params: Object.create(null),
        icon: <RiTicketLine />,
        title: "Create a Ticket",
        shouldShowAlways: false,
        showPermission: Permission.TicketCreateGuest,
        hidePermission: Permission.ChatsModifyAll,
        description: "Create a new request or ticket.",

    },

    {
        id: CREATE_REQUEST_ID,
        to: Paths.AGENT_CHAT,
        params: { chatId: "new" },
        icon: <RiTicketLine />,
        title: "Create a Ticket",
        shouldShowAlways: false,
        showPermission: Permission.ChatsModifyAll,
        description: "Create a new request or ticket.",

    },

    {
        id: "agent-compose",
        to: Paths.AGENT_COMPOSE,
        params: Object.create(null),
        icon: <RiChatNewLine />,
        title: "Compose a Message",
        shouldShowAlways: false,
        showPermission: Permission.ChatsModifyAll,
        description: "Compose a message to send to a one or many channels.",

    },
    {
        id: "knowledge",
        to: Paths.ANSWERS_LIST,
        params: Object.create(null),
        icon: <RiBookMarkedLine />,
        title: "Answers",
        shouldShowAlways: true,
        showPermission: Permission.ChatsModifyAll,
        hidePermission: Permission.Administrator,
        description: "Create or view knowledge base articles.",

    },
    {
        id: "contacts",
        to: Paths.CONTACTS,
        params: Object.create(null),
        icon: <RiTeamLine />,
        title: "Contacts",
        shouldShowAlways: false,
        showPermission: Permission.ChatsModifyAll,
        description: "View all contacts and organizations.",

    },

    {
        id: "users",
        to: Paths.ADMINISTRATOR_SETTING,
        params: { setting: "users" },
        icon: <RiUserLine />,
        title: "Set up Users",
        shouldShowAlways: false,
        showPermission: Permission.Administrator,
        description: "Add more agents or administrators.",

    },
    {
        id: "time",
        to: Paths.ADMINISTRATOR_SETTING,
        params: { setting: "time" },
        icon: <RiTimeLine />,
        title: "Set up off-hours",
        shouldShowAlways: false,
        showPermission: Permission.Administrator,
        description: "Set up off-hours and display a message when you are away.",

    },
    {
        id: "feedback",
        to: Paths.ADMINISTRATOR_SETTING,
        params: { setting: "feedback" },
        icon: <RiThumbUpLine />,
        title: "Set up Feedback",
        shouldShowAlways: false,
        showPermission: Permission.Administrator,
        description: "Set the integrated Feedback.",

    },
    {
        id: "queues",
        to: Paths.ADMINISTRATOR_SETTING,
        params: { setting: "queues" },
        icon: <RiStackLine />,
        title: "Set up Queues",
        shouldShowAlways: false,
        showPermission: Permission.Administrator,
        description: "Configure queues which manage ticket routing.",

    },
    {
        id: "services",
        to: Paths.ADMINISTRATOR_SETTING,
        params: { setting: "workflow-services" },
        icon: <RiFlashlightLine />,
        title: "Integrations",
        shouldShowAlways: false,
        showPermission: Permission.Administrator,
        description: "Configure integrations with your standard tools.",
    },
    // {
    //     id: CLEAR_REQUEST_ID,
    //     to: Paths.ADMINISTRATOR,
    //     params: Object.create(null),
    //     icon: <BsGearFill />,
    //     title: "Clear",
    //     showPermission: Permission.Administrator,
    //     description: "View and manage all settings",
    // },
    {
        id: "settings",
        to: Paths.ADMINISTRATOR_SETTING,
        params: { setting: "home" },
        icon: <RiSettings3Line />,
        title: "Settings",
        shouldShowAlways: true,
        showPermission: Permission.Administrator,
        description: "View and manage all settings",
    },

    {
        id: "my-profile",
        to: Paths.ACCOUNT_PROFLE,
        params: Object.create(null),
        icon: <RiUser3Fill />,
        title: "My Profile",
        shouldShowAlways: true,
        showPermission: Permission.ChatsModifyAll,
        description: "View my profile and personal settings.",
    },

];

function LabelContainer({
    children,
    label,
    className,
}: {
    children: ReactNode;
    label: string
    className?: string
}) {
    return (
        <div className={classNames(Styles["label-container"], className)}>
            <Badge variant="gray" className={Styles["label-container-title"]}>{label}</Badge>
            {children}
        </div>
    );
}
LabelContainer.defaultProps = {
    className: "",
};

function ActionButton({
    icon,
    label,
    isCompleted,
    setting,
    isOptional,
}: {
    icon: ReactNode;
    label: string;
    isCompleted: boolean;
    setting: string;
    isOptional?: boolean
}) {
    return (
        <NavLink
            isButton
            variant="outline-gray"
            to={Paths.ADMINISTRATOR_SETTING}
            params={{ setting }}
        >
            <span className="btn-text">
                {icon}
                {" "}
                {label}
                {isOptional && <span className="btn-text-optional"> (Optional)</span>}

            </span>
            {isCompleted ? (
                <RiCheckboxCircleFill className="btn-postfix-icon completed" />
            ) : (
                <RiArrowRightSLine className="btn-postfix-icon" />
            )}
        </NavLink>
    );
}
ActionButton.defaultProps = {
    isOptional: false,
};

function getStartDate() {
    const date = new Date();
    date.setMonth(date.getMonth() - 1);
    return date;
}

export default function Home(): ReactElement {
    const { getSearchParams } = useRouting();
    const { permissions, user } = useCurrentSession();
    const { data: onboardingData } = useGetOnboardingProfileQuery({
        skip: !permissions.has(Permission.Administrator),
        fetchPolicy: "network-only",
    });

    const { progressPercent, isDone, homeStepsCompleted } = useProfile(onboardingData?.onboardingProfile as OnboardingProfile);

    const [saveProfile] = useSaveOnboardingProfileMutation();
    const searchParams = getSearchParams(Paths.HOME);
    const { isOnboarded } = searchParams;
    const { startDate, endDate } = useMemo(() => ({
        startDate: getStartDate(),
        endDate: new Date(),
    }), []);

    const { data: reportsData, loading: isLoadingReports } = useGetReportsDataQuery({
        variables: {
            input: {
                id: REPORT_ID,
                startDate,
                endDate,
            },
        },
    });

    const isShowOnboarding = permissions.has(Permission.Administrator) && !isDone;
    const steps = NEXT_STEPS.filter(step => permissions.has(step.showPermission)
            && (!step.hidePermission || !permissions.has(step.hidePermission))
            && (step.shouldShowAlways || !homeStepsCompleted.has(step.id)))
        .limit(isShowOnboarding ? 4 : 6);

    useArticleContext(isOnboarded ? ARTICLES.ONBOARDING_HOME_PAGE : ARTICLES.HOME_PAGE);

    const saveStepVisited = async (stepId: string) => {
        homeStepsCompleted.add(stepId);
        if (permissions.has(Permission.Administrator)) {
            await saveProfile({
                variables: {
                    profile: {
                        homeStepsCompleted: stepId === CLEAR_REQUEST_ID ? [] : Array.from(homeStepsCompleted),
                    },
                },
            });
        }
    };

    const rowGroups = useMemo(() => reportsData?.metricsDashboardWithData?.data.toIdMap("dataSource", rowData => {
        const columnIndexMap = rowData?.columns.map((row, index) => ({ id: row.id, index })).toIdMap("id", "index") ?? {};
        const labelMap = rowData?.labels.toIdMap("id", "label") ?? {};
        return {
            rows: rowData,
            columnIndexMap,
            labelMap,
        };
    }) ?? {}, [reportsData?.metricsDashboardWithData]);

    return (
        <div>
            <TopPanel title="Welcome" />

            <div className={Styles.header}>
                <h1>
                    👋 Hey
                    {" "}
                    {user?.firstName}
                    ,
                    {" "}
                    Welcome to Foqal
                </h1>

            </div>

            <div className={Styles.content}>
                <div className={Styles["content-left"]}>
                    {isShowOnboarding && (
                        <LabelContainer label="Onboarding" className={Styles["onboarding-container"]}>
                            <h2>Onboarding</h2>
                            <p>Continue onboarding to get the most out of Foqal</p>
                            <div>
                                <ProgressBar value={Math.min(progressPercent, 1)} variant="progress" shouldShowLabel />
                            </div>
                            <RouterLink
                                variant="ghost-blue"
                                to={Paths.ADMINISTRATOR_SETTING}
                                params={{ setting: "home" }}
                                prefixIcon={<Icon.Rocket />}
                                metricPath={["home", "quick-links", "onboarding-continue"]}
                            >
                                Continue Onboarding
                            </RouterLink>
                        </LabelContainer>
                    )}
                    <LabelContainer label="Next Steps" className={Styles["next-steps-container"]}>
                        <h2>Quick Links</h2>
                        <p>
                            These quick links jump you straight
                            to the tasks you’ll likely need next.
                        </p>
                        <div className={Styles["list-actions"]}>
                            {steps.map(action => (
                                <RouterLink
                                    variant="outline-gray"
                                    to={action.to}
                                    params={action.params}
                                    className={Styles["list-actions-item"]}
                                    postfixIcon={<RiArrowRightSLine />}
                                    prefixIcon={action.icon}
                                    metricPath={["home", "quick-links", action.id]}
                                    onClick={async () => {
                                        await saveStepVisited(action.id);
                                    }}
                                >
                                    <div className={Styles["list-actions-item-title"]}>
                                        {action.title}
                                    </div>
                                </RouterLink>
                            ))}
                        </div>
                    </LabelContainer>
                </div>
                <div className={Styles["report-container"]}>
                    {isLoadingReports ? (
                        <div className={Styles["report-container-loading"]}>
                            <LoadingIcon />
                        </div>
                    ) : (
                        <ReportDisplay
                            key={reportsData?.metricsDashboardWithData?.dashboard.id}
                            graphs={reportsData?.metricsDashboardWithData?.dashboard
                                .settings.graphs.map(row => ({ ...row })) ?? []}
                            isAdmin={false}
                            rowGroups={rowGroups as Record<string, RowGroup>}
                            onChange={() => {
                            //
                            }}
                            createMenu={() => null}
                            className={Styles["report-container-display"]}
                        />
                    )}
                    <div className={Styles["report-container-footer"]}>
                        <RouterLink
                            variant="none"
                            to={Paths.REPORTS}
                            size="medium"
                            postfixIcon={<RiArrowRightSLine />}
                            metricPath={["home", "quick-links", "more-reports"]}
                        >
                            <Text as="span" textVariant="body-2-regular">
                                More Reports
                            </Text>
                        </RouterLink>
                        <Text textVariant="body-2-regular" colorVariant="body-secondary">
                            Report Range:
                            {" "}
                            <ShortDateRange startDate={startDate} endDate={endDate} />
                        </Text>
                    </div>
                </div>
            </div>

            <Footer />

        </div>

    );
}
